export class BaseComponent {

  constructor() {
  }
  
  convertInternationalToDecimal(value: string | number | null): number {
    if (value === null) {
      return 0;
    }
    if (typeof value === 'number') {
      return value;
    }
    // Remove all commas and convert to number
    const cleanValue = value.replace(/,/g, '');
    // Convert to float, if conversion fails return 0
    const numericValue = parseFloat(cleanValue);
    return isNaN(numericValue) ? 0 : numericValue;
  }
    
}